import React from 'react';
import HighlightBanner from '@hpstellar/core/HighlightBanner';

import withPageComponents from '../../page/components/with-page-components';

import './product-listing-hero-banner.less';

const ProductListingHeroBanner = ({ productListingHeroBanner }) => {
    if (!productListingHeroBanner || !productListingHeroBanner[0]) return null;
    return <HighlightBanner {...productListingHeroBanner[0]} slim />;
};

export default withPageComponents(ProductListingHeroBanner, { components: ['productListingHeroBanner'] });
